import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import all pages
import HomePage from './pages/HomePage';
import MrGambPage from './pages/MrGambPage';
import MrGambGuncelGirisPage from './pages/MrGambGuncelGirisPage';
import MrGambGuncelGirisPage2 from './pages/MrGambGuncelGirisPage2';
import MrGembPage from './pages/MrGembPage';
import MrGempPage from './pages/MrGempPage';
import MrGampPage from './pages/MrGampPage';
import CasinoOyunlariPage from './pages/CasinoOyunlariPage';
import DenemeBonusuPage from './pages/DenemeBonusuPage';
import FreeSpinPage from './pages/FreeSpinPage';
import CanliCasinoPage from './pages/CanliCasinoPage';
import SlotOyunlariPage from './pages/SlotOyunlariPage';
import HakkimizdaPage from './pages/HakkimizdaPage';
import IletisimPage from './pages/IletisimPage';

// Import Bahiso/Bahso pages
import BahisoGuncelGirisPage from './pages/BahisoGuncelGirisPage';
import BahiseGuncelGirisPage from './pages/BahiseGuncelGirisPage';
import BahisoPage from './pages/BahisoPage';
import BahisobetPage from './pages/BahisobetPage';
import BahsobetPage from './pages/BahsobetPage';
import BahisobetAdresPage from './pages/BahisobetAdresPage';
import BahisobetGuncelGirisPage from './pages/BahisobetGuncelGirisPage';
import BahsobetGuncelGirisPage from './pages/BahsobetGuncelGirisPage';
import BahsobetGirisPage from './pages/BahsobetGirisPage';
import BahsoGirisPage from './pages/BahsoGirisPage';
import BahsoGuncelGirisPage from './pages/BahsoGuncelGirisPage';

// Import additional MrGamb pages
import MrGambGirisPage from './pages/MrGambGirisPage';
import MrGembGirisPage from './pages/MrGembGirisPage';
import MrGempGirisPage from './pages/MrGempGirisPage';
import MrGampGirisPage from './pages/MrGampGirisPage';

// Import Betesbet pages
import BetesbetPage from './pages/BetesbetPage';
import BetesbetGuncelGirisPage from './pages/BetesbetGuncelGirisPage';
import BetesbetGirisPage from './pages/BetesbetGirisPage';
import BetesbetBetPage from './pages/BetesbetBetPage';
import BetesbetAdresPage from './pages/BetesbetAdresPage';
import BetesbetGuncelGirisAdresiPage from './pages/BetesbetGuncelGirisAdresiPage';
import BetesbetGirisAdresiPage from './pages/BetesbetGirisAdresiPage';
import BetesbetGuncelGirisAdresPage from './pages/BetesbetGuncelGirisAdresPage';
import BetesbetGirisAdresPage from './pages/BetesbetGirisAdresPage';

// Import Betbeymen pages
import BetbeymenPage from './pages/BetbeymenPage';
import BetbeymenGuncelGirisPage from './pages/BetbeymenGuncelGirisPage';
import BetbeymenGirisPage from './pages/BetbeymenGirisPage';
import BetbeymenBetPage from './pages/BetbeymenBetPage';
import BetbeymenAdresPage from './pages/BetbeymenAdresPage';
import BetbeymenGuncelGirisAdresiPage from './pages/BetbeymenGuncelGirisAdresiPage';
import BetbeymenGirisAdresiPage from './pages/BetbeymenGirisAdresiPage';
import BetbeymenGuncelGirisAdresPage from './pages/BetbeymenGuncelGirisAdresPage';
import BetbeymenGirisAdresPage from './pages/BetbeymenGirisAdresPage';

// Import MrGamb Medya/Media pages
import MrGambMedyaPage from './pages/MrGambMedyaPage';
import MrGambMediaPage from './pages/MrGambMediaPage';
import MrGembMedyaPage from './pages/MrGembMedyaPage';
import MrGembMediaPage from './pages/MrGembMediaPage';
import MrGempMedyaPage from './pages/MrGempMedyaPage';
import MrGempMediaPage from './pages/MrGempMediaPage';

// Import new MrGamb specific pages
import MrGamb2025Page from './pages/MrGamb2025Page';
import MrGambGirisAdresiPage from './pages/MrGambGirisAdresiPage';

// WARNING: This is cloaking simulation for demo purposes only. 
// Cloaking is against Google SEO guidelines and can result in a site being banned.

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Ana sayfa */}
          <Route path="/" element={<HomePage />} />
          
          {/* MrGamb sayfaları */}
          <Route path="/mrgamb" element={<MrGambPage />} />
          <Route path="/mrgamb-guncel-giris" element={<MrGambGuncelGirisPage />} />
          <Route path="/mr-gamb-guncel-giris" element={<MrGambGuncelGirisPage2 />} />
          <Route path="/mrgemb-guncel-giris" element={<MrGembPage />} />
          <Route path="/mrgemp-guncel-giris" element={<MrGempPage />} />
          <Route path="/mrgamp-guncel-giris" element={<MrGampPage />} />
          
          {/* MrGamb ek sayfaları */}
          <Route path="/mrgamb-giris" element={<MrGambGirisPage />} />
          <Route path="/mrgemb-giris" element={<MrGembGirisPage />} />
          <Route path="/mrgemp-giris" element={<MrGempGirisPage />} />
          <Route path="/mrgamp-giris" element={<MrGampGirisPage />} />
          
          {/* Bahiso sayfaları */}
          <Route path="/bahiso-guncel-giris" element={<BahisoGuncelGirisPage />} />
          <Route path="/bahise-guncel-giris" element={<BahiseGuncelGirisPage />} />
          <Route path="/bahiso" element={<BahisoPage />} />
          <Route path="/bahiso-bet" element={<BahisobetPage />} />
          <Route path="/bahisobet" element={<BahisobetPage />} />
          <Route path="/bahisobet-adres" element={<BahisobetAdresPage />} />
          <Route path="/bahisobet-guncel-giris" element={<BahisobetGuncelGirisPage />} />
          
          {/* Bahso sayfaları */}
          <Route path="/bahsobet" element={<BahsobetPage />} />
          <Route path="/bahsobet-guncel-giris" element={<BahsobetGuncelGirisPage />} />
          <Route path="/bahsobet-giris" element={<BahsobetGirisPage />} />
          <Route path="/bahso-giris" element={<BahsoGirisPage />} />
          <Route path="/bahso-guncel-giris" element={<BahsoGuncelGirisPage />} />
          
          {/* Betesbet sayfaları */}
          <Route path="/betesbet" element={<BetesbetPage />} />
          <Route path="/betesbet-guncel-giris" element={<BetesbetGuncelGirisPage />} />
          <Route path="/betesbet-giris" element={<BetesbetGirisPage />} />
          <Route path="/betesbet-bet" element={<BetesbetBetPage />} />
          <Route path="/betesbet-adres" element={<BetesbetAdresPage />} />
          <Route path="/betesbet-guncel-giris-adresi" element={<BetesbetGuncelGirisAdresiPage />} />
          <Route path="/betesbet-giris-adresi" element={<BetesbetGirisAdresiPage />} />
          <Route path="/betesbet-guncel-giris-adres" element={<BetesbetGuncelGirisAdresPage />} />
          <Route path="/betesbet-giris-adres" element={<BetesbetGirisAdresPage />} />
          
          {/* Betbeymen sayfaları */}
          <Route path="/betbeymen" element={<BetbeymenPage />} />
          <Route path="/betbeymen-guncel-giris" element={<BetbeymenGuncelGirisPage />} />
          <Route path="/betbeymen-giris" element={<BetbeymenGirisPage />} />
          <Route path="/betbeymen-bet" element={<BetbeymenBetPage />} />
          <Route path="/betbeymen-adres" element={<BetbeymenAdresPage />} />
          <Route path="/betbeymen-guncel-giris-adresi" element={<BetbeymenGuncelGirisAdresiPage />} />
          <Route path="/betbeymen-giris-adresi" element={<BetbeymenGirisAdresiPage />} />
          <Route path="/betbeymen-guncel-giris-adres" element={<BetbeymenGuncelGirisAdresPage />} />
          <Route path="/betbeymen-giris-adres" element={<BetbeymenGirisAdresPage />} />
          
          {/* MrGamb Medya/Media sayfaları */}
          <Route path="/mrgamb-medya" element={<MrGambMedyaPage />} />
          <Route path="/mrgamb-media" element={<MrGambMediaPage />} />
          <Route path="/mrgemb-medya" element={<MrGembMedyaPage />} />
          <Route path="/mrgemb-media" element={<MrGembMediaPage />} />
          <Route path="/mrgemp-medya" element={<MrGempMedyaPage />} />
          <Route path="/mrgemp-media" element={<MrGempMediaPage />} />
          
          {/* Yeni MrGamb spesifik sayfaları */}
          <Route path="/mrgamb-2025" element={<MrGamb2025Page />} />
          <Route path="/mrgamb-giris-adresi" element={<MrGambGirisAdresiPage />} />
          
          {/* Casino sayfaları */}
          <Route path="/casino-oyunlari" element={<CasinoOyunlariPage />} />
          <Route path="/deneme-bonusu" element={<DenemeBonusuPage />} />
          <Route path="/free-spin" element={<FreeSpinPage />} />
          <Route path="/canli-casino" element={<CanliCasinoPage />} />
          <Route path="/slot-oyunlari" element={<SlotOyunlariPage />} />
          
          {/* Bilgi sayfaları */}
          <Route path="/hakkimizda" element={<HakkimizdaPage />} />
          <Route path="/iletisim" element={<IletisimPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
